import { SMART_CONTRACT_PLUGIN_IDS, SMART_CONTRACT_TYPES } from "../../../components/SmartContractDesigner/smartContractPluginIDs";

// Plugins config
export const diagramPlugins = (state) => state.diagramPlugins;
export const selectedPluginCode = (state) => state.selectedPluginCode;
export const redoCache = (state) => state.redoCache;

export const selectedFunctionVariables = (state) => (!state.inEditFunction ? []
    : [
        ...state.inEditFunction.body.flatMap(elem => (elem.nodeType === "DECLARE" ? elem.declareList.map(declaration => ({
            label: declaration.variable,
            value: declaration.variable,
            isArray: declaration.isArray,
            type: declaration.type
        })) : null), 1).filter(elem => !!elem),
        ...state.inEditFunction.inParameters.map(elem => ({
            label: elem.name,
            value: elem.name,
            isArray: elem.isArray,
            type: elem.type
        }))
    ]);
export const selectedFunctionOutputVariables = (state) => (!state.inEditFunction ? [] : state.inEditFunction.outParameters.map(elem => ({
    label: elem.name,
    value: elem.name,
    isArray: elem.isArray,
    type: elem.type
})));

export const getSmartContractsNumber = (state) => state.scNumber;

export const selectedPluginUuid = (state) => state.selectedPluginUuid;
export const smartContractPluginCategories = (state) => state.smartContractPluginCategories;
export const diagramData = (state) => {
    let functionIndex;
    if (state.inEditFunction) {
        functionIndex = state.applicationFunctions.findIndex(func => func.id === state.inEditFunction.id);
    }
    return functionIndex !== -1 && functionIndex !== undefined ? state.applicationFunctions[functionIndex].diagramData : {};
};
export const selectedPluginData = (state) => state.selectedPluginData;
export const hasSelectedFunction = (state) => !!state.selectedFunction;
export const selectedFunction = (state) => state.selectedFunction;
export const applicationFunctions = (state) => state.applicationFunctions;
export const smartContractList = (state) => state.smartContractList;
export const functionSelected = (state) => state.functionSelected;
export const staticVariables = (state) => state.staticVariables;
export const applicationFunctionsAsDDL = (state) => {
    const appDDL = state.applicationFunctions.map((func, index) => ({
        label: func.name || `Function: ${index}`,
        inset: false,
        sublabel: func.description || " ",
        value: func.id
    }));
    appDDL.sort((firstEl, secondEl) => ((firstEl.label > secondEl.label) ? 1 : ((secondEl.label > firstEl.label) ? -1 : 0)));
    return appDDL;
};

export const functionsSignatures = (state) => state.functionsSignatures;

export const functionSignaturesAsDDL = (state) => state.functionsSignatures.map(func => {
    const funcCopy = { ...func };
    funcCopy.label = funcCopy.name;
    funcCopy.sublabel = funcCopy.description || " ";
    funcCopy.value = funcCopy.id;
    return funcCopy;
}).filter(func => (!state.inEditFunction ? true : func.id !== state.inEditFunction.id));

export const functionSignaturesAsObjectMap = (state) => {
    const toReturn = {};

    state.functionsSignatures.forEach(func => {
        const funcCopy = { ...func };
        funcCopy.label = funcCopy.name;
        funcCopy.sublabel = funcCopy.description || " ";
        funcCopy.value = funcCopy.id;
        toReturn[funcCopy.value] = funcCopy;
        toReturn[funcCopy.value].inParameters.forEach((inParam) => {
            inParam.ddl = collectScope(state, inParam);
        });
    });
    return toReturn;
};

const collectScope = function (state, inParam) {
    const val = [];
    const uuid = state.selectedPluginUuid;

    const nodes = state.inEditFunction ? state.inEditFunction.body : null;
    if (!uuid || !nodes) {
        return val;
    }
    val.push(...state.inEditFunction.inParameters.map(param => (param.type === inParam.type && param.isArray === inParam.isArray ? {
        value: param.name,
        label: param.name,
        sublabel: param.description
    } : null)).filter(elem => elem));
    val.push(
        ...nodes.filter(node => node.type === SMART_CONTRACT_TYPES.SMART_CONTRACT_DECLARE)
            .flatMap(declareNode => (!declareNode.declareList ? [] : declareNode.declareList.map((declaration) => (declaration.type === inParam.type && declaration.isArray === inParam.isArray ? {
                label: declaration.name,
                value: declaration.name,
                sublabel: declaration.description
            } : null)).filter(elem => elem)), 1)
    );
    return val;
};

export const selectedPluginComponent = (state) => {
    if (!state.selectedPluginCode) {
        return null;
    }
    switch (state.selectedPluginCode) {
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_INPUT: return "inputHandler";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_OUTPUT: return "outputHandler";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_ASSIGN: return "assignHandler";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DECLARE: return "declareHandler";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_EXPRESSION: return "expressionHandlerWrapper";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_IF: return "ifHandler";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DO_WHILE: return "doWhileHandler";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_WHILE: return "whileHandler";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FOR: return "forHandler";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FUNCTION_CALL: return "callHandler";
        case SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_EMIT_EVENT: return "emitEventHandler";
    }
};
export const existingFunctionsAsDDL = (state) => state.existingFunctionsAsDDL;
export const formattedPreviewFunction = (state) => state.formattedPreviewFunction;
export const appBlockchainLanguage = (state) =>
    // TODO: This needs to be retrieve from the currently selected app data, when the functionality will be done.
    state.appBlockchainLanguage;

export const inEditFunction = (state) => state.inEditFunction;
export const selectedPluginInformationData = (state) => state.selectedPluginInformationData;
export const smartContractValidationModel = (state) => state.smartContractValidationModel;

export const getDiagramError = (state) => state.diagramValidationErr;
export const getSaveDigramaData = (state) => state.saveDigramaData;

export const formattedSmartContract = (state) => state.formattedSmartContract;
export const getterScTypes = (state) => state.bcTypes;

export const getCurrentContractData = (state) => state.currentContract;

export const getterScCredentials = (state) => state.bcCredentials;
export const getterScNetworks = (state) => state.bcNetworks;
export const getContractSameNetwork = (state) => state.scSameNetwork;

export const getEventsContract = (state) => state.events;
export const getAllTemplate = (state) => state.templates;
